exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#copy-rek {\n  font-size: 1.5em;\n}\n.tooltip.fade.top.in {\n  display: inline-block !important;\n  top: -15px !important;\n  left: 0 !important;\n}\n", ""]);

// exports
